var _path, _circle, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfTunisia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 800,
    viewBox: "-60 -40 120 80",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#e70013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-60-40H60v80H-60z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    r: 20
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 15
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 4,
    r: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-5 0l16.281-5.29L1.22 8.56V-8.56L11.28 5.29z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfTunisia);
export default __webpack_public_path__ + "static/media/Flag_of_Tunisia.e0e889d93f7c1d69b938760f405b1360.svg";
export { ForwardRef as ReactComponent };